// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"418dfeca","381":"44df09eb","806":"544bcb95"}[chunkId] + ".chunk.css";
};